import { cn } from '../../utils/helpers';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info';
type BadgeSize = 'sm' | 'md';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  const variants = {
    default: 'bg-[#22222e] text-[#94a3b8] border-[#2a2a3a]',
    success: 'bg-green-500/10 text-[#22c55e] border-green-500/20',
    warning: 'bg-amber-500/10 text-[#f59e0b] border-amber-500/20',
    error: 'bg-red-500/10 text-[#ef4444] border-red-500/20',
    info: 'bg-blue-500/10 text-[#3b82f6] border-blue-500/20',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full border',
        variants[variant],
        sizes[size],
        className
      )}
    >
      {children}
    </span>
  );
}
